import React from "react";
import Topics from "../Topics/Topics/Topics";

const Home = () => {
  return (
    <div>
      <h2>we provide the best math courses.</h2>
      <p>select the courses you want to buy</p>
      <p>
        For every student, every classroom. Real results. We’re a nonprofit with
        the mission to provide a free, world-class education for anyone,
        anywhere. Students practice at their own pace, first filling in gaps in
        their understanding and then accelerating their learning. Differentiate
        your classroom and engage every student. You can learn anything. You’re
        joining a global classroom.
      </p>
      <Topics></Topics>
    </div>
  );
};

export default Home;
